import {
    headers, FETCH_VISITOR_RECEIPT_LIST, fetchVisitorReceiptListUrl, fetchAuthReport, GET_RECEIPT_PDF_ACTION_TYPE, visitorReceiptShareUrl, VISITOR_RECEIPT_SHARE_ACTION_TYPE, GET_VISITOR_PROFORMA_INVOICE, getVisitorProformaInvoiceUrl,
    GET_VISITOR_RECEIPT_NO,
    getVisitorReceiptNoUrl,
    GET_VISITOR_RECEIPT_DETAILS,
    getVisitorReceiptDetailsUrl,
    generateVoucherVisitorUrl,
    RECEIPT_GENERATE_VISITOR_VOUCHER_ACTION_TYPE,
    addReceiptVisitorUrl,
    RECEIPT_ENTRY_ACTION_TYPE,
    RECEIPT_UPDATE_ACTION_TYPE,
    updateReceiptVisitorUrl,
    deleteVisitorReceiptDetailsUrl,
    RECEIPT_DEL_ACTION_TYPE,
    RECEIPT_SHARE_ACTION_TYPE,
    receiptVisitorShareUrl
} from "../../../utils/constants"
import { axiosPost, axiosGet } from "../../../react_axios/Axios"
import moment from 'moment';

export const fetchVisitorReceiptList_action = (visitor, recptDtFrom, recptDtTo, recptNo) => async (dispatch) => {

    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            AccountID: sessionStorage.getItem('RoleIDSS') == 1 ? sessionStorage.getItem('ExhRegistrationIDSS') : null,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            token: 'token',
            Exhibitor: visitor,
            receiptFromDate: recptDtFrom != "" ? (moment(recptDtFrom).format('MM-DD-YYYY')) : null,
            receiptToDate: recptDtTo != "" ? (moment(recptDtTo).format('MM-DD-YYYY')) : null,
            receiptNo: recptNo
        }
        console.log("ReceiptListSearch -Action--------------------------->", params)

        const res = await axiosGet(fetchVisitorReceiptListUrl, params, headers);
        dispatch({
            type: FETCH_VISITOR_RECEIPT_LIST,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }

}

export const getVisitorReceiptPdf_action = (receptId) => async (dispatch) => {
    try {
        var list = [];
        const mapdata1 = {
            ParameterName: "@ReceiptID",
            ParameterValue: receptId,
            ParameterDataType: "int",
        }
        list.push(mapdata1);
        const mapData = {
            user_id: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            report_name: "VisitorReceiptVoucher.rpt",
            report_file_name: `VisitorReceiptVoucher${receptId}`,
            parameter_details: list,
        }
        const res = await axiosPost(fetchAuthReport, mapData);
        dispatch({
            type: GET_RECEIPT_PDF_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const visitorReceiptShare_action = (receiptIdArray) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ReceiptShareID: receiptIdArray,
        }
        console.log("pendingReceiptDetails_action-Action--------------------------->", params)

        const res = await axiosPost(visitorReceiptShareUrl, params, headers);
        dispatch({
            type: VISITOR_RECEIPT_SHARE_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getVisitorProformaInvoice_action = (ExhAccountID, ExhVisitorID) => async (dispatch) => {

    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            AccountID: JSON.parse(sessionStorage.getItem('loginDataSS')).AccountID,
            ExhVisitorID: ExhVisitorID,
            ExhAccountID: ExhAccountID,
            token: sessionStorage.getItem('tokenSS')
        }
        console.log("ReceiptList-Action--------------------------->", params)

        const res = await axiosGet(getVisitorProformaInvoiceUrl, params, headers);
        dispatch({
            type: GET_VISITOR_PROFORMA_INVOICE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }

}

export const getVisitorReceiptNo_action = (exhibitorId) => async (dispatch) => {

    try {
        const params = {
            AccountID: exhibitorId,
            exhibitionid: sessionStorage.getItem('sessionExhibitionID')
        }

        const res = await axiosGet(getVisitorReceiptNoUrl, params, headers);
        dispatch({
            type: GET_VISITOR_RECEIPT_NO,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }

}

export const getVisitorReceiptDetails_action = (receiptID) => async (dispatch) => {

    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            AccountID: JSON.parse(sessionStorage.getItem('loginDataSS')).AccountID,
            receiptID: receiptID,
            token: sessionStorage.getItem('tokenSS')
        }
        console.log("ReceiptList-Action--------------------------->", params)

        const res = await axiosGet(getVisitorReceiptDetailsUrl, params, headers);
        dispatch({
            type: GET_VISITOR_RECEIPT_DETAILS,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }

}

export const generateVoucherVisitor_action = (voucherTypeId, exhibitorId, bankAccountId, currency,
    conRate, bankAmount, tdsAmount, exchdiif, onAccAmt, crAmount, totalAmount,
    proformaList, otherChargesList, recptId) => async (dispatch) => {
        try {
            const mapData = {
                UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
                AccountID: JSON.parse(sessionStorage.getItem('loginDataSS')).AccountID,
                token: sessionStorage.getItem('tokenSS'),
                voucherTypeId: voucherTypeId,
                ExhibitorId: exhibitorId,
                BankAccountId: bankAccountId,
                currency: currency,
                conRate: conRate,
                BankAmount: bankAmount,
                TDSAmount: tdsAmount,
                ExchDiff: exchdiif,
                onAccAmt: onAccAmt,
                CrAmount: crAmount,
                TotalAmount: totalAmount,
                proformaList: proformaList,
                otherChargesList: otherChargesList,
                receiptId: recptId != '' ? recptId : 0,
                exhibitionid: sessionStorage.getItem('sessionExhibitionID')
            }
            console.log("Generate Voucher Action --------->", mapData)
            const res = await axiosPost(generateVoucherVisitorUrl, mapData, headers);
            dispatch({
                type: RECEIPT_GENERATE_VISITOR_VOUCHER_ACTION_TYPE,
                payload: res,
            })
            return Promise.resolve(res)
        } catch (error) {
            return Promise.reject(error)
        }
    }

export const receipt_entry_save_action = (voucherTypeId, exhibitorId, bankAccountId, currencyId, conRate, bankAmount, tdsAmount, exchdiif,
    onAccAmt, crAmount, totalAmount, recptNo, recptDate, pymtModeId, paymentReceivedDate, instrNo, instruDate, bankName,
    branchName, narration, checklnvListData, OtherChargesListData, accPaymentId, exhregistrationID, SD, ledgerList, ExhVisitorID) => async (dispatch) => {
        try {
            const mapdata = {
                UserID: parseInt(JSON.parse(sessionStorage.getItem('loginDataSS')).UserID),
                Token: 'token',
                LogedinAccountID: parseInt(JSON.parse(sessionStorage.getItem('loginDataSS')).AccountID),
                ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
                ExhRegistrationID: exhregistrationID,
                ReceiptID: null,
                VoucherTypeID: parseInt(voucherTypeId),
                ExhAccountID: parseInt(exhibitorId),
                BankID: parseInt(bankAccountId),
                CurrencyID: parseInt(currencyId),
                ConversionRate: parseFloat(conRate).toFixed(2),
                BankAmount: bankAmount != "" && bankAmount != null ? parseFloat(bankAmount).toFixed(2) : parseFloat(0).toFixed(2),
                TDSAmount: tdsAmount != "" && tdsAmount != null ? parseFloat(tdsAmount).toFixed(2) : parseFloat(0).toFixed(2),
                ExchangeDifference: exchdiif != "" && exchdiif != null ? parseFloat(exchdiif).toFixed(2) : 0,
                OnAccAmount: parseFloat(onAccAmt).toFixed(2),
                CreditAmount: parseFloat(crAmount).toFixed(2),
                TotalAmount: parseFloat(totalAmount).toFixed(2),
                ReceiptNo: recptNo,
                ReceiptDate: recptDate,
                PaymentModeID: parseInt(pymtModeId),
                PaymentReceivedDate: paymentReceivedDate,
                InstrumentNo: instrNo != "" ? instrNo : 0,
                InstrumentDate: instruDate,
                BankName: bankName,
                BranchName: branchName,
                Narration: narration,
                proformaList: checklnvListData,
                otherChargesList: OtherChargesListData,
                AccountPaymentID: accPaymentId != "" ? accPaymentId : null,
                SecurityDeposite: SD != '' && SD != null ? SD : 0,
                ledgerList: ledgerList,
                ExhVisitorID: ExhVisitorID
            }
            console.log("Receiptentry-Action--------------------------->", mapdata)
            const res = await axiosPost(addReceiptVisitorUrl, mapdata, headers);

            dispatch({
                type: RECEIPT_ENTRY_ACTION_TYPE,
                payload: res,
            })
            return Promise.resolve(res);
        } catch (err) {
            return Promise.reject(err);
        }
    }


export const receiptUpdate_action = (recptId, voucherTypeId, exhibitorId, bankAccountId, currencyId, conRate, bankAmount, tdsAmount,
    exchdiif, onAccAmt, crAmount, totalAmount, recptNo, recptDate, paymentReceivedDate, pymtModeId, instrNo, instruDate, bankName, branchName,
    narration, checklnvListData, OtherChargesListData, exhregistrationID, SD, ledgerList, ExhVisitorID) => async (dispatch) => {
        try {
            console.log('BankAmount : ', bankAmount);
            const mapData = {
                UserID: parseInt(JSON.parse(sessionStorage.getItem('loginDataSS')).UserID),
                Token: 'token',
                ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
                ExhRegistrationID: exhregistrationID,
                LogedinAccountID: parseInt(JSON.parse(sessionStorage.getItem('loginDataSS')).AccountID),
                ReceiptID: parseInt(recptId),
                VoucherTypeID: parseInt(voucherTypeId),
                ExhAccountID: parseInt(exhibitorId),
                BankID: parseInt(bankAccountId),
                CurrencyID: parseInt(currencyId),
                ConversionRate: parseFloat(conRate).toFixed(2),
                BankAmount: bankAmount != "" && bankAmount != null ? parseFloat(bankAmount).toFixed(2) : parseFloat(0).toFixed(2),
                TDSAmount: tdsAmount != "" && tdsAmount != null ? parseFloat(tdsAmount).toFixed(2) : parseFloat(0).toFixed(2),
                ExchangeDifference: exchdiif != "" && exchdiif != null ? parseFloat(exchdiif).toFixed(2) : parseFloat(0).toFixed(2),
                OnAccAmount: parseFloat(onAccAmt).toFixed(2),
                CreditAmount: parseFloat(crAmount).toFixed(2),
                TotalAmount: parseFloat(totalAmount).toFixed(2),
                ReceiptNo: recptNo,
                ReceiptDate: recptDate,
                PaymentReceivedDate: paymentReceivedDate,
                PaymentModeID: parseInt(pymtModeId),
                InstrumentNo: instrNo != "" ? instrNo : 0,
                InstrumentDate: instruDate,
                BankName: bankName,
                BranchName: branchName,
                Narration: narration,
                proformaList: checklnvListData,
                otherChargesList: OtherChargesListData,
                SecurityDeposite: SD != '' && SD != null ? SD : 0,
                ledgerList: ledgerList,
                ExhVisitorID: ExhVisitorID


            }
            console.log("ReceiptList-Action Update--------------------------->", mapData);
            const res = await axiosPost(updateReceiptVisitorUrl, mapData, headers);
            dispatch({
                type: RECEIPT_UPDATE_ACTION_TYPE,
                payload: res
            })
            return Promise.resolve(res)
        } catch (error) {
            return Promise.resolve(error)
        }
    }


export const deleteVisitorReceipt_action = (receiptId) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            // AccountID: JSON.parse(sessionStorage.getItem('loginDataSS')).AccountID,
            receiptID: receiptId,
            // token: 'token'
        }
        console.log("Delete Receipt Entry Action---------------->", params)
        const res = await axiosGet(deleteVisitorReceiptDetailsUrl, params, headers);
        dispatch({
            type: RECEIPT_DEL_ACTION_TYPE,
            payload: res
        })
        return Promise.resolve(res)

    } catch (error) {
        return Promise.reject(error)
    }
}

export const receiptVisitorShare_action = (receiptIdArray) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ReceiptShareID: receiptIdArray,
        }
        console.log("pendingReceiptDetails_action-Action--------------------------->", params)

        const res = await axiosPost(receiptVisitorShareUrl, params, headers);
        dispatch({
            type: RECEIPT_SHARE_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};